/** Presentacion de la campana de notificaciones. Solo formato y una validacion de enlaces. */

/** Numero del globito: nada si no hay, y "9+" para no desbordarlo. */
export function badgeLabel(unread: number): string {
  if (unread <= 0) return '';
  return unread > 9 ? '9+' : String(unread);
}

/**
 * El enlace de una notificacion viene del backend (payload del evento). Solo se navega a rutas INTERNAS de la app:
 * cualquier otra cosa (URL absoluta, `//otro.sitio`, `javascript:`) se descarta.
 */
export function safeLink(link: string | null | undefined): string | null {
  if (!link || !link.startsWith('/') || link.startsWith('//') || link.includes('\\')) return null;
  return link;
}

/** "3 novedades" cuando varias del mismo tipo se colapsaron en una; vacio si es una sola. */
export function countLabel(count: number): string {
  return count > 1 ? `${count} novedades` : '';
}
